import {Concept} from 'domainTypes';
import {parse} from 'services/utils';

export type GlobalSearchQuery =
  | {type: 'isbn'; value: string}
  | {type: 'uuid'; value: string}
  | {type: Concept.work; value: string}
  | {type: Concept.agent; value: string};

const isbnPattern = /^\d{13}$/;
const uuidPattern =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const urnTypes = [Concept.work, Concept.agent] as const;

const parseUrn = (query: string): GlobalSearchQuery | undefined => {
  try {
    const {type, uuid} = parse(query);
    const knownType = urnTypes.find(urnType => urnType === type);
    return knownType ? {type: knownType, value: uuid} : undefined;
  } catch {
    // Not a URN
    return undefined;
  }
};

export const parseGlobalSearchQuery = (
  query: string,
): GlobalSearchQuery | undefined => {
  const trimmed = query.trim();

  if (uuidPattern.test(trimmed)) {
    return {type: 'uuid', value: trimmed};
  }

  const digits = trimmed.replaceAll('-', '');
  if (isbnPattern.test(digits)) {
    return {type: 'isbn', value: digits};
  }

  return parseUrn(trimmed);
};
